import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import TextCard, { ITextCard } from "@/components/cards/TextCard";

// --------------------------------------------------------------------------------------

export type ICourseLocationProps = HTMLAttributes<HTMLElement> & {
  locationData?: ITextCard[];
};

const CourseLocation: FC<ICourseLocationProps> = (props) => {
  const { locationData, className, ...other } = props;

  return (
    <section
      className={clsx(
        "container grid grid-cols-1 gap-5 py-5 md:grid-cols-2 lg:gap-8 lg:py-8 xl:grid-cols-3 xl:py-[50px]",
        // "container grid grid-cols-1 gap-8 py-5 md:grid-cols-2 lg:py-8 lg:py-[50px] xl:grid-cols-3",
        className,
      )}
      {...other}
    >
      {locationData?.map((data, idx) => (
        <TextCard
          key={idx}
          subHeading={data.subHeading}
          heading={data.heading}
          description={data.description}
          descriptionClass="lg:w-2/3"
        />
      ))}
    </section>
  );
};

export default CourseLocation;
